import ACallingResponseStatus from './index.vue';

ACallingResponseStatus.install = app => {
  app.component(ACallingResponseStatus.name, ACallingResponseStatus);
};

export default ACallingResponseStatus;
